module.exports = __webpack_public_path__ + "img/golden-3.9486437b.png";